import React from 'react';

import { YourPlanWidget } from '@/features/credits';
import { Card, Heading, Subtitle } from '@trevor/ui-components';
import { useDatasourceCountPerSubscription } from '@/features/credits/hooks/useDatasourceCountPerSubscription';
import { HowYouUseCredits } from '@/features/credits/components/HowYouUseCredits/HowYouUseCredits';
import { YourPlanUsage } from '@/features/credits/components/YourPlanUsage';
import {
  ColumnContainer,
  CreditsContainer,
  LeftColumn,
} from './Credits.styles';

const Credits: React.FC = () => {
  const numberOfDatasourcesPerSubscription =
    useDatasourceCountPerSubscription();

  return (
    <CreditsContainer>
      <Heading variant={1}>Credits</Heading>
      <Card padding={16}>
        <Subtitle variant={1}>
          Displaying credit usage from {numberOfDatasourcesPerSubscription}
          &nbsp;datasources
        </Subtitle>
      </Card>
      <ColumnContainer>
        <LeftColumn>
          <YourPlanUsage />
          <HowYouUseCredits />
        </LeftColumn>
        <YourPlanWidget />
      </ColumnContainer>
    </CreditsContainer>
  );
};

export default Credits;
